import { useSelector } from 'react-redux';
import Storage from '../../storage';
import { getCurrentUserState } from '../selectors';

const useCurrentUser = () => {
  const currentUserState = useSelector(getCurrentUserState);
  return {
    isAuthenticated: !!Storage.authToken,
    currentUser: currentUserState.data,
    currentUserLoading: currentUserState.isLoading,
    currentUserError: currentUserState.hasError,
  };
};
export default useCurrentUser;
